import { IconChartBar, IconFlame, IconSparkles } from "@tabler/icons-react";
import Image from "next/image";

export const FiltersData = [
  {
    id: "trending",
    title: "Trending",
    selectedGlow: "glowRed",
    icon: <IconFlame className="size-5" />,
  },
  {
    id: "builder",
    title: "Builder Tokens",
    selectedGlow: "glowBlue",
    icon: (
      <Image
        className="w-fit h-5"
        src="/assets/blue_pill.png"
        alt="blue pill"
        width={46}
        height={46}
      />
    ),
  },
  {
    id: "degen",
    title: "Degen Tokens",
    selectedGlow: "glowRed",
    icon: (
      <Image
        className="w-fit h-5"
        src="/assets/red_pill.png"
        alt="red pill"
        width={46}
        height={46}
      />
    ),
  },
  {
    id: "market_cap",
    title: "Top",
    selectedGlow: "glowGreen",
    icon: <IconChartBar className="size-5" />,
  },
  {
    id: "createdAt",
    title: "New",
    selectedGlow: "glowPurple",
    icon: <IconSparkles className="size-5" />,
  },
];
